import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { SlLEContext } from '../../global-constants';
import { SlDataService } from '../../services/sl-data.service';
import { LocalizedLink } from '../../../../shared/public/LocalizedLink/LocalizedLink';

import s from './ProgrammingLanguages.scss';
import { i18n } from '../../../../symphony';

export function ProgrammingLanguages() {
	useStyles(s);
	const { programmingLanguages$: programmingLanguages } = useContainerData(
		SlLEContext,
		SlDataService,
		['programmingLanguages$'],
	);

	return (
		<div className="le-courses-catalog-programming-languages">
			<div className="le-courses-catalog-programming-languages__title">
				{i18n.t('web-le.languages-catalog-title')}
			</div>
			<div className="le-courses-catalog-programming-languages__list">
				{programmingLanguages?.map((language) => (
					<div
						className="le-courses-catalog-programming-languages__item"
						key={language.key}
					>
						<LocalizedLink
							to={`/learn/languages/${language.alias}`}
						>
							{language.name}
							{' '}
						</LocalizedLink>
					</div>
				))}
			</div>
		</div>
	);
}
